var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("actions " + _vm.alignment)},_vm._l((_vm.buttonActions),function(item,index){return _c('block-buttons-item',{key:index,attrs:{"button-item":item},on:{"button-click":_vm.onButtonClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }